<template>
	<Transition name="slide-bottom">
		<div class="bottom-sheet" v-if="open">
			<div class="bottom-sheet__overlay" @click="open = false"></div>
			<div class="bottom-sheet__modal" :style="{ height: props.height }">
				<LoadingOverlay v-if="loading" />
				<div class="bottom-sheet__header">
					<button class="btn-icon" :class="{ 'btn-chevron': props.closeIcon === 'chevron' }" @click="close">
						<img v-if="props.closeIcon === 'chevron'"
							class="bottom-sheet__icon-header bottom-sheet__icon-header--chevron" :src="chevronUpIcon" />
						<img v-else class="bottom-sheet__icon-header" :src="closeIcon" />
					</button>
					{{ props.title }}
					<button class="btn-icon" :class="{
						'bottom-sheet__icon-hidden': !props.showCartIcon,
						'bottom-sheet__badge': cart.length > 0,
					}" @click="openCart = true">
						<img class="bottom-sheet__icon-header bottom-sheet__icon-header--cart" :src="cartIcon" />
					</button>
				</div>
				<div class="bottom-sheet__content">
					<div class="bottom-sheet__content-inner">
						<slot></slot>
					</div>
				</div>
				<div class="bottom-sheet__action" v-if="$slots['action']">
					<slot name="action"></slot>
				</div>
			</div>
		</div>
	</Transition>
</template>

<script setup>
import closeIcon from "@/assets/media/icons/close-2.svg";
import chevronUpIcon from "@/assets/media/icons/chevron-up.svg";
import cartIcon from "@/assets/media/icons/cart.svg";
import { computed } from "vue";
import { useCartIntegration } from "@/vue/composables/useCartIntegration";
import LoadingOverlay from "./LoadingOverlay.vue";
const props = defineProps({
	title: String,
	height: String,
	showCartIcon: {
		type: Boolean,
		default: true,
	},
	closeIcon: {
		type: String,
		default: "x",
	},
	modelValue: {
		type: Boolean,
		default: false,
	},
	loading: {
		type: Boolean,
		default: false
	}
});
const emit = defineEmits(["update:modelValue", "close"]);
const { openCart, cart } = useCartIntegration();
const open = computed({
	get() {
		return props.modelValue;
	},
	set(newValue) {
		emit("update:modelValue", newValue);
	},
});

function close() {
	open.value = false;
	emit("close");
}
</script>
